import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  FormControlLabel, 
  CardHeader,
  CardContent,
  FormControl,
  Radio,
  Card,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import "./css/InverterSelectorForm.css";

export class InputVoltageView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //Setting this true will always show next button
      // False == Disabled is true
      showNextButton: this.props.ivData === "" ? false : true,
      inputVolt: this.props.ivData,
    };
    this.props.showNextButton(this.props.ivData === "" ? false : true);

  }

  saveInputVoltage = (event) => {
    //console.log("save Input voltage");
    //console.log(event.target.value);
    this.setState({ inputVolt: event.target.value });
    this.props.setIVData(event.target.value);
    //this.setState({ showNextButton: true });
    if(this.props.data.ovData !== ""){
      this.props.showNextButton(true)
    }else{
      this.props.showNextButton(false)

    }
  };

  render() {

    const { singlePhase, threePhase } = this.props;

    return (
      //App starts here

      <Card>
        <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }}
          className="paperh-title"
          title={<h2>Input Voltage</h2>}
          subheader="Select Your Input Requirements"
        />
        <CardContent>
          {!singlePhase && (
            <Paper elevation={10} style={{padding:10}}>
              <FormControl>
                <FormLabel style={{fontFamily: 'Ford-Normal'}} id="">
                  Note: The higher the voltage the smaller the wires and will be
                  more cost effective to wire.
                </FormLabel>
                <RadioGroup
                  style={{fontFamily: 'Ford-Normal'}}
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={this.saveInputVoltage}
                  defaultValue={this.state.inputVolt}
                  sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                >
                  <FormControlLabel
                    value="120V, 1P"
                    control={<Radio />}
                    label="120V, 1P"
                  />
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="208V, 2P"
                      control={<Radio />}
                      label="208V, 2P"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="240V, 2P"
                      control={<Radio />}
                      label="240V, 2P"
                    />
                  )}
                  {(
                    <FormControlLabel
                      value="277V, 1P"
                      control={<Radio />}
                      label="277V, 1P"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="480V, 2P"
                      control={<Radio />}
                      label="480V, 2P"
                    />
                  )}
                </RadioGroup>
              </FormControl>
            </Paper>
          )}

          {!threePhase && (
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                Note: The higher the voltage the smaller the wires and will be
                more cost effective to wire.
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                onChange={this.saveInputVoltage}
                defaultValue={this.state.inputVolt}
                sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
              >
                <FormControlLabel
                  value="208Y/120"
                  control={<Radio />}
                  label="208Y/120"
                />
                <FormControlLabel
                  value="480Y/277"
                  control={<Radio />}
                  label="480Y/277"
                />
              </RadioGroup>
            </FormControl>
          )}
        </CardContent>
        {/* <NavRow
          next={this.props.next}
          previous={this.props.previous}
          showNextButton={showNextButton}
          showPrevButton={true}
        /> */}
      </Card>
    );
  }
}

export default InputVoltageView;
